<div class="popup" *ngIf="isVisibleDetails">
    <div class="container-detalles panelDetailLocations" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches)}">
      <loading [isLoading]="isLoading"></loading>
  
      <div *ngIf="!mobileQuery.matches" class="btnClose">
        <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false" aria-label="Example home icon" fontIcon="cancel" (click)="CancelButton()"></mat-icon>
      </div>

      <div *ngIf="!mobileQuery.matches" class="arrow-container">
          <mat-icon *ngIf="!fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_up</mat-icon>
          <mat-icon *ngIf="fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_down</mat-icon>
      </div>
      <div class="details-flex">
  
        <!-- Primera sección -->
        <div class="header_panel">
  
           <!-- Componente de lista de reportes (se pasa tentativamente al mismo flex que la barra de herraminetas) -->
           <!-- <div class="btnMenuSecondary">
            <app-report-list [identifier]="locationDTO.identifier" [isDetailLocations]="true"></app-report-list>
           </div> -->
  
            <!-- ? --> 
            <div>
              <a class="btnBlokingActions" *ngIf="isVisibleBloking && 'BloquearRuptela-L' | permissionFilter" (click)="OpenBlokingDialog()">
                <mat-icon aria-hidden="false" aria-label="Example home icon">{{ blokingIcon }}</mat-icon>
              </a>
            </div>
  
            <!-- Botón regresar-->
            <a class="btnReturn" (click)="CancelButton()" matTooltip="Regresar"><mat-icon>arrow_back_ios</mat-icon></a>
  
            <!-- Encabezado -->
            <div *ngIf="images.length == 0" class="header-background" [ngClass]="{'col-3': !mobileQuery.matches}">
              <img [src]=" locationDTO.panelIcon | findUrl" class="img-car" />
            </div>

            <!-- carrusel -->
            <div *ngIf="images.length > 0 && mobileQuery.matches" style="height: 200px;">
              <carousel [images]="images"></carousel>
            </div>
  
            <!-- VIN-->
            <div class="row header-text" [ngClass]="{'col-9': !mobileQuery.matches}">
              <label *ngIf="!mobileQuery.matches" class="header-text-label">Id</label>
              <label class="titlePanel vin-title"> 
                {{ this.locationDTO.identifier }}
                <div class="copy-to-clipboard" (click)="copyToClipboard(locationDTO.identifier)">
                  <mat-icon>content_copy</mat-icon>
                </div>
              </label>
              <label class="subtitlePanel"> {{this.locationDTO.categoryStatus}}</label>
              
              <label *ngIf="!mobileQuery.matches" class="header-text-label">Descripción</label>
              <label class="subtitlePanel"> {{this.locationDTO.description}}</label>
            </div>
  
        </div>
        <!-- seccion de herramientas -->
        <div class="button-tool-list">
          <div class="col-10">
            <location-button-toolbar [identifier]="locationDTO.identifier"
                                      [isDetailLocations]="true"
                                      [isReloadable]="true"
                                      [isMonitor]="mobileQuery.matches"
                                      [images]="images"
                                      [CordX]="locationDTO.cordsX"
                                      [CordY]="locationDTO.cordsY"
                                      [isLoadingParent]="isLoading" ></location-button-toolbar>
          </div>
      
          <div class="col-2">
            <app-report-list [identifier]="locationDTO.identifier" 
                               [isDetailLocations]="true"></app-report-list>
            <!-- <div class="tool-option" > </div> -->
          </div>
        </div>
        <!-- seccion de tabs -->
        <div class="tab-group">
          <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="selectTab($event)">
            <mat-tab>
              <ng-template mat-tab-label >
                <label  matTooltip="Resumen del Activo" matTooltipPosition="above">
                <mat-icon class="example-tab-icon">info</mat-icon>
                 Detalle Activo </label>
              </ng-template>
              <ng-template matTabContent >
                <div class="tab-content-wrapper">
                  <!-- Primera sección datos del activo-->
                  <div [ngClass]="{'container': mobileQuery.matches}">
                    <div class="row text-header">
                      <div class="section-header-background">
                        <h3>Datos del Activo</h3>
                      </div>
                    </div>
    
                    <div *ngFor="let key of detallesActivo;let i = index" >
                      <div *ngIf="getNameVisibility(key)" class="row row-data" [ngClass]="{'background-shade': (i % 2 == 0)}">
                        <div class="col-4 d-flex align-items-center">
                          <label class="header_panel titlePanel">{{ getUsableName(key) }}</label>
                        </div>
                        <div class="col-8 d-flex align-items-center general-data">
                          <div>{{ Values[Keys.indexOf(key)] }}</div>
                        </div>
                      </div>  
                    </div>
                    <div class="row row-data">
                      <div class="col-4 d-flex align-items-center">
                        <label class="header_panel titlePanel">Coordenadas</label>
                      </div>
                      <div class="col-8 d-flex align-items-center">
                        <div class="general-data">{{ this.Coords }}</div>
                      </div>
                    </div>
                  </div>
    
                  <!-- Segunda sección Datos GPS-->
                  <div [ngClass]="{'container': mobileQuery.matches}" class="lastSection" *ngIf="detallesGPS.length > 0">
                    <div class="row text-header">
                      <div class="section-header-background">
                        <h3>Datos del GPS</h3>
                      </div>
                    </div>
            
                    <div *ngIf="getNameVisibility('StatusGPS')" class="row row-data background-shade">
                      <div class="col-4 d-flex align-items-center">
                        <label class="header_panel titlePanel">{{ getUsableName('StatusGPS') }}</label>
                      </div>
                      <div class="col-8 d-flex align-items-center general-data">
                        <div>{{ locationDTO.statusGPS }}</div>
                      </div>
                    </div>
            
                    <div *ngFor="let key of detallesGPS;let i = index" >
                      <div *ngIf="getNameVisibility(key)" class="row row-data" [ngClass]="{'background-shade': (i % 2 != 0)}">
                        <div class="col-4 d-flex align-items-center">
                          <label class="header_panel titlePanel">{{ getUsableName(key) }}</label>
                        </div>
                        <div class="col-8 d-flex align-items-center general-data">
                          <div>{{ Values[Keys.indexOf(key)] }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
              </ng-template>
            </mat-tab>

            <div *ngFor="let routeSheet of routeSheets; let i = index">
              <mat-tab  class="categoryTabLabel">
                <ng-template mat-tab-label>
                  <!-- <img [src]="routeSheet.category.icon | findUrl" width="30px" class="mr-5">  -->
                  <label matTooltipPosition="above">
                    {{ routeSheet.total }} {{routeSheet.routeSheetName}}
                  </label> 
                </ng-template>

                <ng-template matTabContent>
                  <div class="tab-content-wrapper">
                    <div [ngClass]="{'container': mobileQuery.matches}">
                       <!-- asociados  -->
                      <app-route-sheet *ngIf="selectedTabIndex === i+1" [identifier]="this.locationDTO.identifier" 
                                                                        [childCategory]="routeSheet.routeSheetIdLocationCategory"
                                                                        [parentCategory]="this.locationDTO.idLocationCategory"
                                                                        [parentCoordX]="this.locationDTO.cordsX"
                                                                        [parentCoordY]="this.locationDTO.cordsY"
                                                                        (categoryTotal)="loadTotal($event, routeSheet)">
                      </app-route-sheet>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>
            </div>

            <!-- <mat-tab *ngIf="hasRelatedData" [disabled]="this.isLoading" class="related">
              <ng-template mat-tab-label >
                <label  matTooltip="Activos Asociados" matTooltipPosition="above">
                <mat-icon class="example-tab-icon">info</mat-icon>
                Asociados </label>
              </ng-template>
              <ng-template matTabContent>
                <div class="tab-content-wrapper">
                  <div class="location-related" [ngClass]="{'container': mobileQuery.matches}">
                    <location-related-list [identifier]="this.locationDTO.identifier" *ngIf="this.selectedTabIndex == 1"></location-related-list>
                  </div>
                </div>
                  
              </ng-template>
            </mat-tab> -->
            
          </mat-tab-group>
        </div>
      </div>  
  
    </div>
  </div>